import BulletList from '@tiptap/extension-bullet-list';
import ListItem from '@tiptap/extension-list-item';
import OrderedList from '@tiptap/extension-ordered-list';
import TextAlign from '@tiptap/extension-text-align';
import { TextStyleKit } from '@tiptap/extension-text-style';
import Underline from '@tiptap/extension-underline';
import { EditorContent, useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import { useEffect } from 'react';
import { ToolbarIcon, ToolType } from './ToolbarIcon';
import './Wysiwyg.scss';
import { WysiwygProps } from './Wysiwyg.types';

export const Wysiwyg: React.FC<WysiwygProps> = ({
  onChange,
  title,
  disabled = false,
  initialContent = '',
}) => {
  const editor = useEditor({
    extensions: [
      StarterKit.configure({
        bulletList: false,
        orderedList: false,
        listItem: false,
      }),

      Underline,
      TextStyleKit,
      BulletList,
      OrderedList,
      ListItem,
      TextAlign.configure({
        types: ['heading', 'paragraph'],
      }),
    ],
    content: initialContent || '',
    editable: !disabled,
    onUpdate: ({ editor }) => {
      const html: string = editor.getHTML();
      onChange(html);
    },
  });
  // Update content if initialContent changes
  useEffect(() => {
    if (!editor) return;
    if (editor.getHTML() === initialContent) return;

    editor.commands.setContent(initialContent || '');
  }, [initialContent, editor]);

  if (!editor) return null;

  return (
    <div className="wysiwyg-wrapper">
      {title && <p className="wysiwyg-editor__title">{title}</p>}
      <div className="wysiwyg-wrapper__toolbar">
        {Object.values(ToolType).map((type) => (
          <ToolbarIcon type={type} editor={editor} />
        ))}
      </div>
      <EditorContent editor={editor} className="wysiwyg-editor" />
    </div>
  );
};
